module.exports = __webpack_public_path__ + "static/media/objects.7d626871.svg";